module.exports = __webpack_public_path__ + "media/interested_companies/images/star10-46361713eae7dabde5552649b79868ef.svg";